import { Container, ContainerItem } from '../common/container/Container'
import { UserProps } from '../modules/users/container'
import { getAppContainer } from './app'
import { moduleURLs } from '../config/api'
import { PROJECT_MODULE, PROJECT_SERVICE_KEY, PROJECT_API_KEY  } from '../modules/projects'
import { ProjectApi } from '../modules/projects/api/ProjectApi'
import { ProjectService } from 'modules/projects/services/ProjectService'

let container: Container

function init(p: UserProps) {
  const items = new Map<symbol, ContainerItem>()

  items.set(PROJECT_API_KEY, new ContainerItem({ instance: new ProjectApi() }))
  items.set(
    PROJECT_SERVICE_KEY,
    new ContainerItem({
      instance: new ProjectService({ apiKey: PROJECT_API_KEY }),
    })
  )

  container = new Container(items, p.parentContainer, p.config)
}

export function getProjectContainer(): Container {
  if (!container) {
    init({
      parentContainer: getAppContainer(),
      config: {
        moduleFullUrl: moduleURLs[PROJECT_MODULE],
      },
    })
  }

  return container
}
